import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPostData } from '../../components/blog/BlogPost';

// Import blog data
import blog1Data from '../../data/blog/blog1';
import blog2Data from '../../data/blog/blog2';
import blog3Data from '../../data/blog/blog3';

// Collect all blog posts in an array
const blogPosts: BlogPostData[] = [
  blog1Data,
  blog2Data,
  blog3Data,
];

// Sort blogs by date (newest first)
const sortedBlogPosts = [...blogPosts].sort((a, b) => {
  return new Date(b.date).getTime() - new Date(a.date).getTime();
});

// Placeholder images - in a real app, these would be added to the blog data
const BLOG_IMAGES: Record<string, string> = {
  'antimicrobial-resistance': '/images/blog/amr1.jpg',
  'antimicrobial-resistance-2': '/images/blog/amr2.jpg',
  'antimicrobial-resistance-3': '/images/blog/amr3.jpg',
};

const BlogIndex: React.FC = () => {
  return (
    <div className="min-h-screen bg-background-alt">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-text mb-4 text-center">Blog</h1>
        <p className="text-lg text-text/70 text-center mb-12 max-w-2xl mx-auto">
          Exploring antimicrobial resistance, laboratory data processing, and healthcare innovation
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sortedBlogPosts.map((post) => (
            <article 
              key={post.id}
              className="flex flex-col h-full bg-background rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden"
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={BLOG_IMAGES[post.slug] || '/images/blog/placeholder.jpg'} 
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
              </div>
              <div className="p-6 flex-grow flex flex-col">
                <Link to={`/blog/${post.slug}`} className="block flex-grow">
                  <h2 className="text-xl font-bold text-primary mb-3 hover:text-primary/80 transition-colors duration-200 line-clamp-2">
                    {post.title}
                  </h2>
                  <p className="text-text/80 mb-4 line-clamp-3">
                    {post.description}
                  </p>
                </Link>
                <div className="mt-auto pt-4 flex items-center justify-between text-sm text-text/60 border-t border-border/30">
                  <div className="flex items-center">
                    <span className="inline-block w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center mr-2">
                      {post.author.name.split(' ').map(name => name[0]).join('')}
                    </span>
                    <span>{post.author.name}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <time dateTime={post.date}>{post.date}</time>
                    <span>•</span>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogIndex; 